import { PLOT_FPS } from '@coderaw/runtime'

/** Season 0 (the kill test) opened Monday 2026-09-28 at 09:00 UTC. The town clock counts from here. */
export const SEASON_START = Date.UTC(2026, 8, 28, 9, 0, 0)

const DAY_MS = 86_400_000

/** Seconds since the season started. The same for every viewer. */
export const townClock = (now: () => number = Date.now): number => (now() - SEASON_START) / 1000

/** Which plot frame a town time falls in. Seeds g.rnd so everyone sees the same pixels. */
export const frameIndex = (t: number): number => Math.floor(t * PLOT_FPS)

/** 0 at midnight UTC, 1 at noon, following a cosine so dusk and dawn are gradual. */
export const dayLight = (now: () => number = Date.now): number => {
  const dayFraction = (((now() % DAY_MS) + DAY_MS) % DAY_MS) / DAY_MS
  return 0.5 - 0.5 * Math.cos(dayFraction * Math.PI * 2)
}
